import { useCallback } from 'react';
import { send } from 'server';
import { pick, prop, path } from 'ramda';
import { languageService } from '@interlayer/js/services/language.service';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

/* core, added default values (line 15, 22) */
export const useGetURLTemplates = () => {
    const lang = useUserSelector(prop('lang'));
    const appCreferer = useUserSelector(path(['userDetails', 'creferer']));
    const appClientPlatform = useDeviceSelector(prop('clientPlatform'));
    const { casinoName: appCasinoName, clientSkin: appClientSkin, clientType: appClientType }
        = useAppSelector(pick(['casinoName', 'clientSkin', 'clientType']));

    return useCallback((
        {
            urlTypeList = [],
            casinoName = appCasinoName,
            clientSkin = appClientSkin,
            clientPlatform = appClientPlatform,
            clientType = appClientType,
            language = lang,
            creferer = appCreferer,
            customParameters
        } = {}
    ) => send({
        ID: 35844,
        responses: [31032, 31033],
        description: 'Get URLs Request',
        urlTypeList,
        casinoName,
        clientSkinName: clientSkin,
        clientPlatform,
        clientType,
        language: languageService.convertToIMS(language),
        creferer,
        customParameters
    }), [appCasinoName, appClientSkin, appClientPlatform, appClientType, lang, appCreferer]);
};
